import * as tslib_1 from "tslib";
import React from 'react';
import { Layouter } from 'pro-gallery-layouter';
import { withMobileContext } from '../Context';
import { applyMassiveThumbThreshold, applyTinyThumbThreshold, didItemsChange, propsItemsOrContainerHasChanged, getStyleParamsWithDefaultsOnce, calcVisibilities, } from './helpers';
import ddt from '@wix/da-ddt';
import ErrorBoundary from '../ErrorBoundary';
import isEqual from 'lodash/isEqual';
var logger = ddt.createLogger('torpedo');
import s from './Torpedo.scss';
import TorpedoStrip from './_partials/Strip';
import TorpedoItemElement from './_partials/Item';
var defaults = {
    layoutConfig: {
        rowSizeDesktop: 270,
        rowSizeMobile: 250,
        rowSizeMobileLarge: 250,
        rowSizeCardDesktop: 360,
        rowSizeCardMobile: 250,
        itemSpacingDesktop: 8,
        itemSpacingMobile: 8,
        itemSpacingCardDesktop: 16,
        itemSpacingCardMobile: 8,
        galleryGutter: false,
    },
};
var Torpedo = /** @class */ (function (_super) {
    tslib_1.__extends(Torpedo, _super);
    function Torpedo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.handleNearHidden = function () {
            _this.setState({ recalcVisibleOnNext: true });
        };
        return _this;
    }
    Torpedo.getDerivedStateFromProps = function (nextProps, prevState) {
        // Any change in items/container requires full re-calc
        if (propsItemsOrContainerHasChanged(nextProps, prevState)) {
            // Calculate options
            var styleParams_1 = getStyleParamsWithDefaultsOnce(defaults, nextProps, prevState);
            var container = nextProps.container;
            // Modify items applying small and massive rules
            var items = nextProps.items || [];
            items = items.map(function (i) { return (tslib_1.__assign({}, i)); }); // clone so we dont mess up references
            items = items.map(applyMassiveThumbThreshold);
            items = items.map(function (item) {
                return applyTinyThumbThreshold(item, styleParams_1.rowSize);
            });
            logger.log('Set derived state', items, styleParams_1, container);
            return {
                items: items,
                container: container,
                layouter: new Layouter({
                    items: items,
                    styleParams: styleParams_1,
                    container: container,
                }),
            };
        }
        // Nothing changed but if we have bounds see if we can recalc
        // the layouts visible items, we also want a re-render here
        // so we set new bounds on state so we can show/hide things
        if (prevState.recalcVisibleOnNext === true &&
            prevState.container &&
            prevState.container.bounds &&
            !isEqual(prevState.container.bounds, nextProps.container.bounds)) {
            calcVisibilities(prevState.layouter, nextProps.container.bounds, nextProps.scrollOptimHints);
            logger.log('layout recalc visible', prevState.layouter);
            return {
                recalcVisibleOnNext: false,
                container: nextProps.container,
            };
        }
        return null;
    };
    /**
     * We handle should update ourselves because layout is
     * expensive. Logic is to check for item length or container
     * changes and addtionally item size changes.
     *
     * @param nextProps
     */
    Torpedo.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var _a = this.props, items = _a.items, container = _a.container;
        if (!isEqual(container, nextProps.container)) {
            return true;
        }
        if (didItemsChange(items, nextProps.items)) {
            return true;
        }
        return false;
    };
    Torpedo.prototype.render = function () {
        var _this = this;
        var layouter = this.state.layouter;
        var _a = this.props, innerRef = _a.innerRef, maxRows = _a.maxRows, hideIncompleteRows = _a.hideIncompleteRows;
        if (!layouter) {
            return (React.createElement(ErrorBoundary, null,
                React.createElement("div", { className: s['root'], ref: innerRef })));
        }
        // Remove the outer gutter, this works by root having
        // overflow:hidden and width set to container.width
        var wrapMargins = {
            marginLeft: "-" + layouter.styleParams.itemSpacing + "px",
            marginTop: "-" + layouter.styleParams.itemSpacing + "px",
            marginBottom: "-" + layouter.styleParams.itemSpacing + "px",
        };
        var strips = layouter.strips;
        if (maxRows && maxRows > 0) {
            strips = strips.slice(0, maxRows);
        }
        // When `hideIncompleteRows` flag is on, don't render rows that do not
        // fill the entire width, except for the first one.
        // This is to avoid having a last row with a few lone items.
        if (hideIncompleteRows) {
            strips = strips.filter(function (strip, index) { return strip.isFullWidth || index === 0; });
        }
        logger.log('layout render');
        return (React.createElement("div", { className: s['root'], ref: innerRef, style: { width: layouter.container.width } },
            React.createElement("div", { style: wrapMargins }, strips.map(function (strip) { return (React.createElement(TorpedoStrip, tslib_1.__assign({ key: strip.idx, onNearHidden: _this.handleNearHidden, strip: strip }, _this.props, { renderItem: function (item) { return (React.createElement(TorpedoItemElement, tslib_1.__assign({ key: "item-" + item.id, item: item }, _this.props))); } }))); }))));
    };
    Torpedo.defaultProps = defaults;
    return Torpedo;
}(React.Component));
export { Torpedo };
export default withMobileContext(Torpedo);
//# sourceMappingURL=Torpedo.js.map